export enum IncentiveFormMode {
  CREATE = 'create',
  EDIT = 'edit'
};

export const isDateValid = (date: Date) => {
  return !Number.isNaN(date.getTime());
};
